export type Role = (typeof Roles)[keyof typeof Roles];

export const Roles = {
  Constructer: 'constructer',
  Owner: 'owner',
  Salesman: 'salesman',
  SuperAdmin: 'sa-role',
} as const satisfies Record<string, string>;

export const Role2DisplayName = {
  'sa-role': 'SuperAdmin',
  owner: 'Majitel',
  salesman: 'Obchodník',
  constructer: 'Montážník',
} satisfies Record<Role, string>;